import { useState } from 'react';
import { Button } from '@mantine/core';
import AddEditOfferModal from './AddEditOfferModal';
import AddEditCouponModal from './AddEditCouponModal';
import './AddEditOfferModal.css';

export default function AddOfferCouponModal({ onClose, onSaved, cloneOffer, cloneCoupon }) {
  const [activeTab, setActiveTab] = useState(cloneOffer ? 'offer' : cloneCoupon ? 'coupon' : 'offer');
  const offerTabId = 'add-offer-coupon-tab-offer';
  const couponTabId = 'add-offer-coupon-tab-coupon';
  const offerPanelId = 'add-offer-coupon-panel-offer';
  const couponPanelId = 'add-offer-coupon-panel-coupon';

  const focusTab = (tab) => {
    const el = document.getElementById(tab === 'offer' ? offerTabId : couponTabId);
    if (el) el.focus();
  };

  const handleTabKeyDown = (e) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveTab('coupon');
      focusTab('coupon');
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveTab('offer');
      focusTab('offer');
    } else if (e.key === 'Home') {
      e.preventDefault();
      setActiveTab('offer');
      focusTab('offer');
    } else if (e.key === 'End') {
      e.preventDefault();
      setActiveTab('coupon');
      focusTab('coupon');
    }
  };

  return (
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-offer-coupon-title"
    >
      <div className="modal">
        <h2 id="add-offer-coupon-title" className="sr-only">
          {cloneOffer ? 'Clone an offer' : cloneCoupon ? 'Clone a coupon' : 'Add or edit a promotion'}
        </h2>
        <div
          role="tablist"
          aria-label="Promotion type"
          style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}
        >
          <Button
            role="tab"
            id={offerTabId}
            aria-controls={offerPanelId}
            aria-selected={activeTab === 'offer'}
            tabIndex={activeTab === 'offer' ? 0 : -1}
            variant={activeTab === 'offer' ? 'filled' : 'default'}
            onClick={() => setActiveTab('offer')}
            onKeyDown={handleTabKeyDown}
          >
            Offer
          </Button>
          <Button
            role="tab"
            id={couponTabId}
            aria-controls={couponPanelId}
            aria-selected={activeTab === 'coupon'}
            tabIndex={activeTab === 'coupon' ? 0 : -1}
            variant={activeTab === 'coupon' ? 'filled' : 'default'}
            onClick={() => setActiveTab('coupon')}
            onKeyDown={handleTabKeyDown}
          >
            Coupon
          </Button>
        </div>
        <div
          role="tabpanel"
          id={offerPanelId}
          aria-labelledby={offerTabId}
          hidden={activeTab !== 'offer'}
        >
          {activeTab === 'offer' && (
            <AddEditOfferModal offer={null} cloneData={cloneOffer || null} onClose={onClose} onSaved={onSaved} isEmbedded />
          )}
        </div>
        <div
          role="tabpanel"
          id={couponPanelId}
          aria-labelledby={couponTabId}
          hidden={activeTab !== 'coupon'}
        >
          {activeTab === 'coupon' && (
            <AddEditCouponModal coupon={null} cloneData={cloneCoupon || null} onClose={onClose} onSaved={onSaved} isEmbedded />
          )}
        </div>
      </div>
    </div>
  );
}